import { iconPaths, type IconName } from './icons.generated';

type Props = { name: IconName; size?: number; className?: string; title?: string };

/** Inline Material Symbols icon. Decorative by default; pass `title` to give it a name. */
export function Icon({ name, size = 20, className = '', title }: Props) {
  return (
    <svg
      viewBox="0 -960 960 960"
      width={size}
      height={size}
      fill="currentColor"
      className={`inline-block shrink-0 ${className}`}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path d={iconPaths[name]} />
    </svg>
  );
}
